"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_stateful_1 = require("@nexys/react-stateful");
exports["default"] = (function (App, permission) {
    if (permission === void 0) { permission = null; }
    return function (props) {
        var permissions = react_stateful_1.Credentials.getPermissions();
        var permissionsChecked = permission === null || (permissions && permissions.includes(permission));
        if (react_stateful_1.Credentials.getProfile() && permissionsChecked) {
            return react_1["default"].createElement(App, __assign({}, props));
        }
        return react_1["default"].createElement(react_router_dom_1.Redirect, { to: "/logout" });
    };
});
